import React, { useState } from 'react';
import PricingTable from '.';

export default function PricingTableList() {
  const [tab, setTab] = useState('installation');

  const handleEmailClick = (packageName) => {
    const subject = `Inquiry about ${packageName} Package`;
    const body = `I am interested in the ${packageName} package. Please provide more information.`;
    const email = 'info@soketrysolutions.com';
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="cs_tabs cs_style1">
      <ul className="cs_tab_links cs_style1 cs_mp0 cs_pricing_control">
        <li
          className={tab === 'installation' ? 'active' : ''}
          onClick={() => setTab('installation')}
        >
          <span>Installation</span>
          <span className="cs_switch"></span>
        </li>
        <li
          className={tab === 'maintenance' ? 'active' : ''}
          onClick={() => setTab('maintenance')}
        >
          <span>5-Year Maintenance Plan</span>
        </li>
      </ul>
      <div className="row cs_gap_y_30">
        <div className="col-lg-4">
          {tab === 'installation' && (
            <PricingTable
              title="Basic Solar Setup"
              subTitle="Ideal for small homes or businesses."
              price="FREE"
              currency=""
              timeline="One-time"
              features={[
                'Up to 5kW Solar Panel Installation',
                'Basic Inverter System',
                'Installation & Setup',
                '1-Year Standard Warranty',
              ]}
              btnText="Select Package"
              onClick={() => handleEmailClick('Basic Solar Setup')}
            />
          )}
          {tab === 'maintenance' && (
            <PricingTable
              title="Basic Maintenance"
              subTitle="Includes regular maintenance and extended warranty."
              price="20000"
              currency="Ksh "
              timeline="5 Years"
              features={[
                'Annual Maintenance Checks',
                'Priority Service Calls',
                'Extended Warranty Coverage',
                'System Performance Monitoring',
              ]}
              btnText="Select Package"
              onClick={() => handleEmailClick('Basic Maintenance')}
            />
          )}
        </div>
        <div className="col-lg-4">
          {tab === 'installation' && (
            <PricingTable
              title="Advanced Solar Solution"
              subTitle="Perfect for larger properties requiring higher energy output."
              price="FREE"
              currency=""
              timeline="One-time"
              features={[
                '10-15kW Solar Panel Installation',
                'High-Efficiency Inverter',
                'Professional Installation',
                'Energy Efficiency Consulting',
              ]}
              btnText="Select Package"
              onClick={() => handleEmailClick('Advanced Solar Solution')}
              popular
            />
          )}
          {tab === 'maintenance' && (
            <PricingTable
              title="Premium Maintenance"
              subTitle="Comprehensive care and performance optimization."
              price="25000"
              currency="Ksh "
              timeline="5 Years"
              features={[
                'Biannual System Checks',
                'Inverter Upgrades',
                '24/7 Monitoring Support',
                'Extended Warranty & Support',
              ]}
              btnText="Select Package"
              onClick={() => handleEmailClick('Premium Maintenance')}
              popular
            />
          )}
        </div>
        <div className="col-lg-4">
          {tab === 'installation' && (
            <PricingTable
              title="Full Off-Grid System"
              subTitle="For complete energy independence."
              price="FREE"
              currency=""
              timeline="One-time"
              features={[
                '20+ kW Solar Panel System',
                'Top-Tier Inverter & Battery Storage',
                'Complete Installation & Grid Integration',
                'Custom Energy Solutions',
              ]}
              btnText="Select Package"
              onClick={() => handleEmailClick('Full Off-Grid System')}
            />
          )}
          {tab === 'maintenance' && (
            <PricingTable
              title="Enterprise Maintenance"
              subTitle="Ultimate performance with dedicated support."
              price="30000"
              currency="Ksh "
              timeline="5 Years"
              features={[
                'Monthly System Checks',
                'Premium Panel Cleaning',
                'Advanced Analytics & Reporting',
                '24/7 Technical Support',
              ]}
              btnText="Select Package"
              onClick={() => handleEmailClick('Enterprise Maintenance')}
            />
          )}
        </div>
      </div>
    </div>
  );
}
